<template>
    <div>
        <h1>{{ transl["STR_TITLE_TESTS"] }}</h1>
        <div>
            <i class="fas fa-search"></i>
            &nbsp;<input style="width: 230px;" type="text" v-model="filter" ref="pp" placeHolder="Suche..." />
        </div>
        <br>
        <table v-if="cycler.length > 1">
            <tr>
                <td width="100"><b>Ger&auml;te Filter:</b></td>
                <td>
                    <select v-model="devicefilter">
                        <option value="99">Alle Ger&auml;te</option>
                        <option v-for="c in cycler" v-bind:key="c.serial" :value="c.serial">{{ c.nick}}</option>
                    </select>
                </td>
            </tr>
        </table>
        <!-- <label>curves: {{ curves }}</label><br>
        <label>transl: {{ transl }}</label><br>
        <label>isAdmin: {{ isAdmin }}</label> -->

        <table border="1">
        <thead>
            <th width="140" @click="sort('time')">
                <i v-if="showUpArrow('time')" class="fas fa-arrow-up"></i>
                <i v-if="showDownArrow('time')" class="fas fa-arrow-down"></i>
                {{transl["STR_DATE_TIME"]}}
            </th>
            <th width="80" @click="sort('probes')" class="hideonmobile">
                <i v-if="showUpArrow('probes')" class="fas fa-arrow-up"></i>
                <i v-if="showDownArrow('probes')" class="fas fa-arrow-down"></i>
                {{transl["STR_PROBES"]}}
            </th>
            <th width="90" @click="sort('probesPositive')">
                <i v-if="showUpArrow('probesPositive')" class="fas fa-arrow-up"></i>
                <i v-if="showDownArrow('probesPositive')" class="fas fa-arrow-down"></i>
                {{transl["STR_POSITIVES"]}}
            </th>
            <th width="90" @click="sort('probesInvalid')">
                <i v-if="showUpArrow('probesInvalid')" class="fas fa-arrow-up"></i>
                <i v-if="showDownArrow('probesInvalid')" class="fas fa-arrow-down"></i>
                {{transl["STR_INVALIDS"]}}
            </th>
            <th width="90" class="hideonmobile" @click="sort('target')">
                <i v-if="showUpArrow('target')" class="fas fa-arrow-up"></i>
                <i v-if="showDownArrow('target')" class="fas fa-arrow-down"></i>
                {{ transl["STR_TEST_TYPE"]}}
            </th>
            <th width="200" @click="sort('cycler')">
                <i v-if="showUpArrow('cycler')" class="fas fa-arrow-up"></i>
                <i v-if="showDownArrow('cycler')" class="fas fa-arrow-down"></i>
                {{ transl["STR_DEVICE"]}}
            </th>
            <th width="90">{{ transl["STR_ACTIONS"]}}</th>
        </thead>
        <tr v-for="t in sortedTests" v-bind:key="t.testid">
            <td>&nbsp;
                <span class="hideonmobile">{{ t.time | unixtimestamp(true) }}</span>
                {{ t.time | unixtimestamp }}
            </td>    
            <td align="center" class="hideonmobile">{{ t.probes }}</td>
            <!-- <td v-if="t.target !== 'lactose'" align="center" :class="{ 'positive' : t.probesPositive > 0 }">{{ t.probesPositive }}</td> -->
            <td v-if="t.target == 'covid19'" align="center" :class="{ 'positive' : t.probesPositive > 0 }">{{ t.probesPositive }}</td>
            <td v-if="t.target == 'rsv'" align="center" :class="{ 'positive' : t.probesPositive > 0 }">{{ t.probesPositive }}</td>
            <td v-if="t.target === 'lactose'" align="center">-</td>
            <td v-if="t.target == 'influenzaab'" align="center" :class="{ 'positive' : t.probesPositive > 0 }">{{ t.probesPositive }}</td>
            <td v-if="t.target == 'cofluenza'" align="center" :class="{ 'positive' : t.probesPositive > 0 }">{{ t.probesPositive }}</td>
            <td v-if="t.target == 'gluten'" align="center" :class="{ 'positive' : t.probesPositive > 0 }">{{ t.probesPositive }}</td>
            <td v-if="t.target == 'fructose'" align="center" :class="{ 'positive' : t.probesPositive > 0 }">{{ t.probesPositive }}</td>
            <td v-if="t.target == 'bonefitness'" align="center" :class="{ 'positive' : t.probesPositive > 0 }">{{ t.probesPositive }}</td>
            <td align="center" :class="{ 'invalid' : t.probesInvalid > 0 }">{{ t.probesInvalid }}</td>
            <td v-if="t.target === 'lactose'" align="center" class="hideonmobile">{{ t.target == "lactose"?"Laktose":t.target }}</td>
            <td v-if="t.target === 'influenzaab'" align="center" class="hideonmobile">{{ t.target == "influenzaab"?"Influenza A/B":t.target }}</td>
            <td v-if="t.target === 'covid19'" align="center" class="hideonmobile">{{ t.target == "covid19"?"Covid19":t.target }}</td>
            <td v-if="t.target === 'rsv'" align="center" class="hideonmobile">{{ t.target == "rsv"?"RSV":t.target }}</td>
            <td v-if="t.target === 'cofluenza'" align="center" class="hideonmobile">{{ t.target == "cofluenza"?"Winterplex":t.target }}</td>
            <td v-if="t.target === 'gluten'" align="center" class="hideonmobile">{{ t.target == "gluten"?"Gluten":t.target }}</td>
            <td v-if="t.target === 'fructose'" align="center" class="hideonmobile">{{ t.target == "fructose"?"Fructose":t.target }}</td>
            <td v-if="t.target === 'bonefitness'" align="center" class="hideonmobile">{{ t.target == "bonefitness"?"Knochenfitness":t.target }}</td>
            <td>&nbsp;{{ getNick(t.cycler) }}</td>
            <td align="center">
                <i v-on:click="getThisTest(t.testid)" class="fas fa-eye" style="cursor: pointer;"></i>
                &ensp;
                <i v-on:click="getPDF(t.testid)" class="fas fa-file-pdf" style="cursor: pointer;"></i>             
            </td>
        </tr>
        <tr v-if="!sortedTests.length">
            <td v-if="this.filter===''" colspan="7" style="padding: 10px;">Sie haben bisher noch keine Tests durchgef&uuml;hrt.</td>
            <td v-else colspan="7" style="padding: 10px;">Die Suche hat nichts gefunden.</td>
        </tr>
        <tr v-if="sortedTests.length">
            <td colspan="50">
                <table style="width: 100%">
                <tfoot>
                    <tr>
                        <td><button v-on:click="page--" :disabled="(this.offset*this.page)-this.offset == 0">&larr;</button></td>
                        <td colspan="3" align="center">Test {{ (this.offset*this.page)-this.offset }} bis  {{ this.offset*this.page }} von {{ this.filteredTests.length  }}</td>
                        <td align="right"><button v-on:click="page++" :disabled="this.offset*this.page >= this.filteredTests.length ">&rarr;</button></td>
                    </tr>
                </tfoot>
                </table>  
            </td>
        </tr>
        </table>
        
        <div style="display: Flex">
            <div class="magic-button" style="margin-right: 15px" v-on:click="getToday">
                {{ transl["STR_DOWNLOAD_TODAY"]}}
            </div>

            <!-- <div class="magic-button" v-on:click="FQDConverter" v-if="curves">
                FQD Importieren
            </div> -->
        </div>

    </div>
</template>
<script>


export default({
    props: [ 'curves','transl','isAdmin' ], // ,'isAdmin'
    filters: {
        unixtimestamp(UNIX_timestamp, toDate) {
            var a = new Date(UNIX_timestamp * 1000);
            var year = a.getFullYear();
            var month = a.getMonth()+1;
            var date = a.getDate();
            var hour = a.getHours();
            var min = a.getMinutes();
            var sec = a.getSeconds();
            if(sec < 10) sec="0"+sec;

            if(date < 10) date="0"+date;
            if(month < 10) month="0"+month;
            if(hour < 10) hour="0"+hour;
            if(min < 10) min="0"+min;
            
            var time

            if(toDate) {
                time = date + '.' + month + '.' + year;
            } else {
                time = hour + ':' + min + ':' + sec ;
            }
            return time;            
        }
    },
    data() {
        return {
            start: 0,
            offset: 20,
            page: 1,
            nicks: [],
            cycler: [],
            devicefilter: 99,
            filter:'',
            currentSort: "time",
            currentSortDir: "desc",
        }
    },
    computed: {
        filteredTests() {
            if(!this.$store.getters.tests.length){
                return [];
            }
            //TODO: check also Lactose as //Laktose!!
            const filterText = this.filter.toLowerCase();
            const filtered = this.$store.getters.tests.filter(t => {
                if(this.filter == '') return true;
                
                let timeText = this.$options.filters.unixtimestamp(t.time, true) + ' ' + this.$options.filters.unixtimestamp(t.time);
                if (t.target == "lactose") {
                    return timeText.indexOf(filterText) >= 0 || 
                        t.testid.toLowerCase().indexOf(filterText) >= 0 ||
                        t.target.toLowerCase().indexOf(filterText.replace("lak","lac")) >= 0; // because of english in db
                }
                return timeText.indexOf(filterText) >= 0 || 
                    t.testid.toLowerCase().indexOf(filterText) >= 0 ||
                    t.target.toLowerCase().indexOf(filterText) >= 0;
            })

            if(this.devicefilter !== 99) {
                return filtered.filter(e => e.cycler == this.devicefilter);
            }
            return filtered;
        },
        sortedTests() {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            const sorted = this.filteredTests.sort((a,b) => {
                let modifier = 1;
                if(this.currentSortDir === 'desc') modifier = -1;

                let aValue;
                let bValue;

                if (this.currentSort === "target") {
                    aValue = a[this.currentSort] === null?'':a[this.currentSort].toLowerCase();
                    bValue = b[this.currentSort] === null?'':b[this.currentSort].toLowerCase();
                } else if (this.currentSort === "cycler") {
                    aValue = this.getNick(a[this.currentSort]).toLowerCase();
                    bValue = this.getNick(b[this.currentSort]).toLowerCase();
                } else { 
                    aValue = a[this.currentSort] === null?'':(a[this.currentSort]);
                    bValue = b[this.currentSort] === null?'':(b[this.currentSort]);
                }

                if(aValue < bValue) return -1 * modifier;
                if(aValue > bValue) return 1 * modifier;
                return 0;
            });
            return sorted.slice((this.offset*this.page)-this.offset,this.offset*this.page);
        }
    },
    watch: {
        filter() {
            //reset to 1 because filter changed
            this.page = 1;
        }
    },
    mounted() {
        this.loadNicks();
        let { device = false } = this.$route.params;
        if(device) {
            this.devicefilter = device;
        }
        // let { isAdmin = false } = this.$route.query;
        // if(isAdmin) {   // achtung es geht nur darum, ob überaupt gesetzt!
        //     this.isAdmin = true;
        // }  
    },
    methods: {
        FQDConverter() {
            this.$router.push({
                name: 'fqd',
            })
        },
        sort(s) {
            //if s == current sort, reverse
            if(s === this.currentSort) {
                this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
            }
            this.currentSort = s;
        },
        getToday() {
            var token = this.$store.getters.accessToken;
            window.open(process.env.VUE_APP_API_SERVER + "/test/exporttoday?token="+token)
        },
        getNick(id) {
            var mm = this.nicks.find(e => e.serial == id);
            if(mm) {
                return mm.name;
            } else {
                if(id.trim() == "") return "N/A";
                return id;
            }
        },
        ShowCurves(id) {
            this.$router.push({
                name: 'ShowCurves',
                params: {
                    testid: id.testid,
                }
            })
        },
        loadNicks() {
            this.nicks = [];
            this.$store.getters.cyclers.forEach((c) => {
                this.nicks.push({
                    serial: c.serial,
                    name: c.name,
                })
            })
        },
        nickname(serial) {
            var find = this.nicks.find(e => e.serial == serial);
            if(find) {
                return find.nick;
            } else {
                return serial;
            }
        },
        getCurves(id) {
            this.$router.push({
                name: 'ShowCurves',
                params: {
                    testid: id,
                }
            })
        },
        getPDF(id) {
            var token = this.$store.getters.accessToken;
            
            //if(this.$store.getters.isAdmin) {  // curves
            if (this.isAdmin) {  // curves
                window.open(process.env.VUE_APP_API_SERVER + "/test/"+id+"/pdf?extended=true&token=" + token);
            } else {
                window.open(process.env.VUE_APP_API_SERVER + "/test/"+id+"/pdf?token=" + token);
            }
        },
        getCSV(id, serial) {
            this.$store.dispatch("LoadProbes", id)
            .then((probes) => {
                var csv = "Barcode;Device;Position;Valid;CT;Positive\n";
                var cycler = this.nickname(serial);
                probes.filter(e => e.barcode.substr(3) !== "NTC" && e.barcode.substr(3) !== "TPC").forEach((p) => {
                    csv+="'"+p.barcode+"';"+cycler+";"+p.well+";"+p.valid+";"+(p.positive && p.valid ? p.ct : "-")+";"+p.positive+"\n";
                })
                var element = document.createElement('a');
                element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv));
                element.setAttribute('download', id+'.csv');
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);                
            })
        },
        getThisTest(id) {
            this.$store.dispatch("LoadProbes", id)
            // eslint-disable-next-line no-unused-vars
            .then((r) => {
                this.$router.push({
                    name: 'ShowThisTest',
                    params: {
                        id: id,
                    }
                })
            })
        },
        showUpArrow(value) {
            return (this.currentSort===value && this.currentSortDir==="asc")
        },
        showDownArrow(value){
            return (this.currentSort===value && this.currentSortDir==="desc")
        }
    }
})
</script>
